export default __webpack_public_path__ + "static/media/add_rule_at_bottom.63c3f2f3.svg";